import context from "../util/context";

export function login(credentials, callback){
    fetch("/auth/login", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
    }).then(function(response) {
        if(response.status === 401 || response.status === 400 || response.status === 500){
            return callback("WRONG_LOGIN") ;
        }
        return response.json();
    }).then(function(results) {
        if(results){
            context.currentUser = results ;
            callback(null, results) ;
        }
    }).catch(function(err){
        context.currentUser = null ;
        callback(err) ;
    }) ;
}

export function refresh(callback){
    fetch("/auth/refresh", {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(function(response) {
        if(response.status === 401){
            return callback("NOT_LOGGED") ;
        }
        return response.json();
    }).then(function(results) {
        context.currentUser = results ;
        callback(null, results) ;
    }).catch(function(err){
        context.currentUser = null ;
        callback(err) ;
    }) ;
}

export function logout(){
    return fetch("/auth/logout", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: "{}"
    }).then(function(response) {
        context.currentUser = null ;
        localStorage.removeItem("jwt-token") ;
        return Promise.resolve() ;
    }).catch(function(err){
        context.currentUser = null ;
        console.log(err) ;
    }) ;
}

export function changePassword(currentPassword, newPassword, callback){
    fetch("/auth/changePassword", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            currentPassword,
            newPassword
        })
    }).then(function(response) {
        if(response.status === 401 || response.status === 400 || response.status === 500){
            return callback("WRONG_PASS") ;
        }
        callback(null) ;
    }).catch(function(err){
        callback(err) ;
    }) ;
}
